import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { combineLatest } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(private authService: AuthService) {
    combineLatest([this.authService.user$, this.authService.client$])
      .pipe(debounceTime(100))
      .subscribe(([user, client]) => {
        Sentry.setUser({
          id: String(user?.id),
          username: user?.username,
          roles: user?.roles,
          email: user?.email,
          subscriptions: client?.subscriptions?.map(el => el.id),
          impersonated: user?.impersonated,
          client: client?.id
        });
      });
  }

  captureError(error: Error) {
    this.logError(error);
    Sentry.captureException(error);
  }

  logError(error: Error | string, level: 'error' | 'warning' = 'error') {
    if (level === 'error') {
      // eslint-disable-next-line no-console
      console.error(error);
    } else if (level === 'warning') {
      // eslint-disable-next-line no-console
      console.warn(error);
    }
  }
}
